<template>
  <section role="region" class="our-differences-section">
    <div class="text">
      <TheSecondHead chipText="Diga adeus" chipColor="blue-light"
        titleText="Com o MeLembre sua empresa pode esquecer esses problemas" />
      <div class="timeline">
        <div class="listItem" v-for="problem in problems" :key="problem.id">
          <div class="circle"></div>
          <p class="subtitle">{{ problem.title }}</p>
          <p class="content">{{ problem.text }}</p>
        </div>
      </div>
    </div>
    <div class="image">
      <ThePicture mobilePath="/images/business/m-homem-computador.png"
        desktopPath="/images/business/homem-computador.png" mobileQuerie="1199px" desktopQuerie="1200px"
        altText="Homem sorrindo de pernas cruzas com notebook no colo" />
    </div>
  </section>
</template>

<script setup lang="ts">


const problems = ref<Array<ContentCardItem>>([
  {
    id: 1,
    title: 'Custo Alto',
    text: 'Processo de comunicação manual, que envolve grandes equipes e diversas funções',
  },
  {
    id: 2,
    title: 'Falta de controle e auditoria',
    text: 'Ausência de rastreabilidades das comunicações realizadas',
  },
  {
    id: 3,
    title: 'Falta de padronização',
    text: 'Mensagens que não refletem a marca, tom de voz e padrão da empresa',
  },
  {
    id: 4,
    title: 'Descentralização das ferramentas de controle',
    text: 'Cuidar de múltiplas ferramentas que não estão integradas, levando a custos elevados e maior tempo gasto',
  },
  {
    id: 5,
    title: 'Pouca eficiência',
    text: 'Baixas taxas de abertura e leitura',
  },
])
</script>

<style lang="scss">
.our-differences-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 40px 20px;
  max-width: 895px;
  margin: 0 auto;

  .text {
    max-width: 452px;
    margin: 0 auto;

    .title {
      margin: 16px 0px 40px;
      width: 90%;
    }

    .timeline {
      .listItem {
        padding-left: 34px;
        margin: 0 auto 0px 14px;

        &:not(:last-child) {
          padding-bottom: 26px;
          border-left: 2px dashed #3303FF;
        }

        .circle {
          position: absolute;
          margin-left: -50px;
          margin-top: -4px;
          border: 6px solid #d4d5ff;
          background-color: #3303ff;
          border-radius: 100%;
          width: 30px;
          height: 30px;
        }

        .subtitle {
          font-weight: 700;
          margin-bottom: 8px;
        }
      }
    }
  }

  .image {
    display: none;
  }

  @media screen and (min-width: 834px) and (max-width: 959px) {
    padding: 69px 0px 69px 32px;

    .text {
      width: 385px;

      .timeline {
        .listItem {
          width: 356px;
        }
      }
    }

    .image {
      .image-component img {
        margin-top: 7em;
      }
    }
  }

  @media screen and (min-width: 834px) and (max-width: 1199px) {
    .image {
      .image-component img {
        width: 402px;
        height: 451px;
      }
    }
  }

  @media screen and (min-width: 960px) and (max-width: 1199px) {
    padding: 68px 32.5px 70px;

    .image {
      .image-component img {
        margin-bottom: 1em;
      }
    }
  }

  @media screen and (min-width: 834px) {

    .text {
      .title {
        width: 448px;
      }

      .timeline .listItem {
        &:not(:last-child) {
          padding-bottom: 32px;
        }

        .subtitle {
          font-size: 18px;
        }
      }
    }

    .image {
      display: unset;
    }
  }

  @media screen and (min-width: 960px) {
    max-width: 1098px;

    .text .timeline .listItem {
      width: 100%;

      &:nth-child(4) {
        width: 452px;
      }

    }

    .image {
      .image-component img {
        margin-bottom: 1em;
      }
    }
  }

  @media screen and (min-width: 1200px) {
    padding: 67px 0px 68px;

    .text .timeline .listItem {
      width: 100%;
    }

    .image {
      .image-component img {
        width: 582px;
        height: 653px;
      }
    }
  }


}
</style>